
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Checkbox } from '@/components/ui/checkbox';
import { FormValues } from './types';

interface BasicInformationProps {
  form: UseFormReturn<FormValues>;
}

const BasicInformation: React.FC<BasicInformationProps> = ({ form }) => {
  return (
    <>
      <FormField
        control={form.control}
        name="title"
        render={({ field }) => (
          <FormItem>
            <FormLabel htmlFor="title">Title</FormLabel>
            <FormControl>
              <Input 
                id="title" 
                name="title" 
                {...field} 
                placeholder="Enter a title for this line item"
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      
      <FormField
        control={form.control}
        name="description"
        render={({ field }) => (
          <FormItem>
            <FormLabel htmlFor="description">Description (optional)</FormLabel>
            <FormControl>
              <Textarea 
                id="description"
                name="description" 
                {...field} 
                placeholder="Enter a detailed description"
                value={field.value || ''} 
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="is_active"
        render={({ field }) => (
          <FormItem className="flex items-start space-x-2">
            <FormControl>
              <Checkbox
                id="is_active"
                name="is_active"
                checked={field.value}
                onCheckedChange={(checked: boolean) => field.onChange(checked)}
              />
            </FormControl>
            <FormLabel htmlFor="is_active" className="font-normal">
              This line item is active and available for use
            </FormLabel>
          </FormItem>
        )}
      />
    </>
  );
};

export default BasicInformation;
